// extracted by mini-css-extract-plugin
module.exports = {"promotionNameInput":"PromotionList_promotionNameInput__yzBqw","filter":"PromotionList_filter__23LRw"};